import React from 'react';
import { createRoot } from 'react-dom/client';
import ErrorsBoundary from './main/application/errorsBoundary';
import Toaster from '../_Apps/eugene/components/Toaster';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import ListingAds from '../ListingAds/containers/index';
import { setupStore } from '../ListingAds/store';

const listingAds = document.getElementById('listing-properties-root');

if (listingAds) {
  const store = setupStore();

  const root = createRoot(listingAds);
  root.render(
    <ErrorsBoundary>
      <Provider store={store}>
        <BrowserRouter>
          <Toaster />
          <ListingAds />
        </BrowserRouter>
      </Provider>
    </ErrorsBoundary>
  );
}
